module.exports = __webpack_public_path__ + "static/media/ExamSetCustomAdd.0de19667.svg";